// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__zGrrE","title":"styles_title__cPa3z","buttons":"styles_buttons__40Bh9","buttons-add":"styles_buttons-add__bG7Ma"};